const REFUNDABLE_ESCROW_STATES = new Set(["open", "claimed", "submitted"]);

export function getExpiredEscrowPresentation(onchainStatus, { unavailable = false } = {}) {
  if (unavailable) {
    return {
      displayState: "expired",
      tone: "warning",
      action: null,
      note: "Escrow status unavailable · refresh to retry"
    };
  }
  if (onchainStatus === "refunded") {
    return {
      displayState: "refunded",
      tone: "muted",
      action: null,
      note: "Refund credited · withdraw when ready"
    };
  }
  if (onchainStatus === "accepted") {
    return {
      displayState: "settled",
      tone: "muted",
      action: null,
      note: "Escrow already settled"
    };
  }
  if (REFUNDABLE_ESCROW_STATES.has(onchainStatus)) {
    return {
      displayState: "expired",
      tone: "warning",
      action: "refund",
      note: "Expired funds remain in escrow"
    };
  }
  return {
    displayState: "expired",
    tone: "warning",
    action: null,
    note: onchainStatus === "none" ? "No funded escrow found" : "Escrow state unknown"
  };
}
